/**
 * Part of earth project.
 *
 * @copyright  Copyright (C) 2018 ${ORGANIZATION}.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import '@unicorn/ui/ui-bootstrap5.js';
import swal from '@sweetalert';
import './mail-subscribe.js?d9ab7f035f41d030bdd7a937';
import './main-header.js?d9ab7f035f41d030bdd7a937';
import './video-embed-helper.js?d9ab7f035f41d030bdd7a937';

u.use(UIBootstrap5.UIBootstrap5);

export default u;

// Mobile menu
// const mobileMenu = $('#mobile-menu');
// console.log(mobileMenu);
// mobileMenu.offcanvas({
//   modifiers: 'left, overlay',
//   triggerButton: '.j-mobile-menu-toggler',
//   closeButtonClass: "j-menu-close",
// });
//
// setTimeout(() => {
//   mobileMenu.show();
// }, 0);

// Alertify
alertify.set('notifier', 'position', 'top-center');

u.notify = (message, type = 'info', options = {}) => {
  return alertify.notify(message, type, options.wait || 5, options.callback || null);
};

// RWD Video
u.rwdVideo = (selector) => {
  const body = $(selector);

  const iframes = body.find('iframe');

  iframes.each((i, ele) => {
    $(ele).wrap(`<div class="rwd-video"></div>`);
  });
};

// Contact Modal
$('.c-contact-modal').on('show.bs.modal', () => {
  u.import('https://www.google.com/recaptcha/api.js?d9ab7f035f41d030bdd7a937');

  window.submitModalContact = function () {
    $('.g-recaptcha').attr('disabled', true);
    document.querySelector('#modal-contact-form').submit();
  };
});

// China footer social tooltip

u.domready(() => {
  let footerTooltip = $('.j-tooltip').tooltip({
    html: true,
  });
});

// Tom Select
u.$ui.tomSelect('.has-tom-select', { maxOptions: null });

// Region Warning from Search Engine
const locationWarning = u.data('location.warning');

if (locationWarning) {
  swal({
    title: u.__('datavideo.lang.search.engine.warning.title', locationWarning.currentTitle),
    text: u.__('datavideo.lang.search.engine.warning.text', locationWarning.title),
    buttons: [
      u.__('datavideo.lang.search.engine.warning.no'),
      u.__('datavideo.lang.search.engine.warning.ok', locationWarning.title)
    ]
  }).then((v) => {
    if (v) {
      location.href = locationWarning.url;
    }
  });
}
